import flagsmith from 'flagsmith';
import jwtDecode from 'jwt-decode';

// Mirrors parseCidList in mekari-builder-dashboard useFeatureToggle.
// A JSON company ID list, [] when unparsable.
const parseCidList = (raw) => {
  try {
    const parsed = JSON.parse(String(raw || '[]'));
    if (!Array.isArray(parsed)) return [];
    return parsed.map(Number).filter(cid => !Number.isNaN(cid));
  } catch (e) {
    return [];
  }
};

// The signed-in company from the session token, null without a valid token.
const sessionCompanyId = () => {
  try {
    const session = jwtDecode(JSON.parse(localStorage.getItem('Token')).value);
    return session.user.company_id;
  } catch (e) {
    return null;
  }
};

export default {
  computed: {
    useChaptchaLogin() {
      return flagsmith.hasFeature('captcha_login');
    },
    // Inverted allowlist: flag off denies, an empty list allows every company,
    // otherwise only listed companies.
    useGen1TwoFactor() {
      if (!flagsmith.hasFeature('rls_gen1_two_factor_auth')) return false;
      const allowedCids = parseCidList(flagsmith.getValue('rls_gen1_two_factor_auth'));
      if (allowedCids.length === 0) return true;
      const companyId = sessionCompanyId();
      if (companyId == null) return false;
      return allowedCids.includes(Number(companyId));
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/jMixFlagsmith.js